import moment from "moment";
import { ProgressBar } from "primereact/progressbar";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ButtonZegel from "../../../components/Buttons/ButtonZegel";
import { PrivateRoutes } from "../../../routes/routes";
import CardCursoVideoInicioComponent from "../CardCursoVideoInicio/CardCursoVideoInicioComponent";
import CardDownloadDesktop from "../CardDownload/components/CardDownloadDesktop";
import useAlumno from "../../../hooks/useAlumno";
import DialogZegel from "../../../components/Dialog/DialogZegel";
import {SolicitarAmpliacion} from "../../../services/UsuarioService";
import ReactPlayer from "react-player";

function CardBienvenida({
  cursoPersona,
  Persona,
  curso,
  cursoExpirado,
  porcentajeCursoAvance,
  cursoExpiradoAmpliacion,
  cursoExpiradoMembresia,
  Evaluaciones,
  listaUnidades,
  spinnerMateriales,
  isButtonDisabledMateriales,
  setContenidoAlertActivar,
  setShowAlert,
  setspinnerMateriales,
  setButtonDisabledMateriales,
  setspinnerCertificado,
  spinnerCertificado,
  setspinnerNotas,
  spinnerNotas,
}) {
  let { configuraciones } = useAlumno();
  const [showAmpliacion, setShowAmpliacion] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  let { idCurso } = useParams();

  //esv 16-04-25
  function calcularPromedioNotasPorUnidad() {

    if (!Evaluaciones || Evaluaciones.length === 0) return 0;
  
    const notasMaximasPorUnidad = new Map();
  
    Evaluaciones.forEach(({ idUnidad, nota }) => {

      const notaMaximaActual = notasMaximasPorUnidad.get(idUnidad) || 0;  //Consulta la nota máxima actual de esa unidad:

      if (nota > notaMaximaActual) {
        notasMaximasPorUnidad.set(idUnidad, nota);
      }

    });
  
    const sumaNotas = Array.from(notasMaximasPorUnidad.values()).reduce((acc, nota) => acc + nota, 0);
    const totalUnidades = notasMaximasPorUnidad.size;
    
    //const sumaNotas = 28;
    //const totalUnidades = 2.001;

    const promedio = totalUnidades === 0 ? 0 : sumaNotas / totalUnidades;
  
    return parseFloat(promedio.toFixed()); 

  }
  
  /*function calcularPromedioNotasPorUnidad() {
    //obtenerPorcentajeAvance();
    if (Evaluaciones) {
      const notasMaximasPorUnidad = {};
      const conteoEvaluacionesPorUnidad = {};
      Evaluaciones.forEach((evaluacion) => {
        const { idUnidad, nota } = evaluacion;
        if (
          !notasMaximasPorUnidad[idUnidad] ||
          nota > notasMaximasPorUnidad[idUnidad]
        ) {
          notasMaximasPorUnidad[idUnidad] = nota;
        }
        if (!conteoEvaluacionesPorUnidad[idUnidad]) {
          conteoEvaluacionesPorUnidad[idUnidad] = 1;
        } else {
          conteoEvaluacionesPorUnidad[idUnidad]++;
        }
      });
      let sumaNotas = 0;
      let totalUnidades = 0;
      for (const unidad in notasMaximasPorUnidad) {
        sumaNotas += notasMaximasPorUnidad[unidad];
        totalUnidades++;
      }
      //sumaNotas = 38;
      //totalUnidades = 4;
      const promedio = totalUnidades === 0 ? 0 : sumaNotas / totalUnidades;
      //esv 16-04-25
      //return promedio.toFixed(2);
      return parseFloat(promedio.toFixed(2)); // esto devuelve NÚMERO
      //end esv
    } else {
      return 0;
    }
  }*/
 //end esv 16-04-25

  const valueTemplate = () => {
    return <React.Fragment>{""}</React.Fragment>;
  };

  const contenidoActivar = (
    <div>
      <span>
        <strong>
          {"¿Estás seguro de que quieres activar el curso " +
            curso.nombre +
            "?"}
        </strong>
      </span>
      <br></br>
      <br></br>
      <span>
        Recuerda que tienes 30 días para culminar el curso, una vez comenzado no
        podrás desactivarlo.{" "}
      </span>
    </div>
  );

  const handleLinkClickCursoBase = () => {
    navigate(
      "/" +
        PrivateRoutes.HOME +
        "/CursoInterno/" +
        cursoPersona[0].idPersonaCurso
    );
  };
  function DiasVigencia() {
    let fechaActual = new Date();
    let diferenciaEnDias = 0;

    let fechaVigenciaMmebresia = new Date(
      cursoPersona[0].fechaVigenciaMembresia
    );

    let fechaCalculable = cursoPersona[0].fechaAmpliacionCurso
      ? new Date(cursoPersona[0].fechaAmpliacionCurso)
      : new Date(cursoPersona[0].fechaVigencia);

    let fechaCalculableFinal = cursoPersona[0].fechaVigenciaMembresia
      ? fechaCalculable > fechaVigenciaMmebresia
        ? fechaVigenciaMmebresia
        : fechaCalculable
      : fechaCalculable;

    let diferenciaEnMilisegundos = fechaCalculableFinal - fechaActual;

    diferenciaEnDias = Math.floor(
      diferenciaEnMilisegundos / (1000 * 60 * 60 * 24)
    );
    //return <span>{diferenciaEnDias + 1}</span>;
    return diferenciaEnDias + 1;
  }
  const footerAmpliacion = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label="Aceptar ampliación"
          color="primary"
          onClick={() => solicitaAmpliacion()}
          loading={loading}
        ></ButtonZegel>
      </div>
      <div>
        <ButtonZegel
          label="Cancelar"
          color="secondary"
          onClick={() => setShowAmpliacion(false)}
        ></ButtonZegel>
      </div>
    </>
  );
  const contenidoAmpliacion = (
    <div>
      <span>
        <strong>{"Recuerda que..."}</strong>
      </span>
      <br></br>
      <span style={{ fontSize: 12 }}>
        Tienes 14 días más para culminar con el curso. Luego de esta ampliación
        el curso quedará expirado permanentemente.{" "}
      </span>
    </div>
  );
  const solicitaAmpliacion = () => {
    setLoading(true);
    let jwt = window.localStorage.getItem("jwt");
    let id = cursoPersona[0].idPersonaCurso;
    SolicitarAmpliacion({ jwt, id })
      .then((data) => {
        setTimeout(() => {
          setLoading(false);
          setShowAmpliacion(false);
          window.location.reload();
        }, 3000);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  return (
    <><div className="p-fluid formgrid grid">
      <div className="field col-12 md:col-7 movilBackground">
        <div
          className=" rounded-9 shadow mb-4 mb-md-4 CardBienvenidaMobile"
          style={{ backgroundColor: "white" }}
        >
          <div className="row g-2 mb-2 align-items-center movilPadding">
            <div className="rounded-10 p-2 p-md-4 mb-4 mb-md-4 ml-2 CardBienvenidaMobile">
              <div className="p-fluid formgrid grid ">
                {cursoExpiradoMembresia ? (
                  cursoPersona[0].idCondicion ? (
                    cursoPersona[0].idEstado == 1 &&
                      cursoPersona[0].idCondicion != 2 &&
                      Evaluaciones &&
                      cursoPersona[0].promedio >=
                      configuraciones?.filter(
                        (z) => z.codigo === "NOTA_MINIMA_APROB"
                      )[0].valor ? (
                      <div className="field col-12 md:col-8 fontsizeinitial">
                        <span class="subtitle h3" data-v-48f3e599="">
                          ¡Felicidades {Persona.nombres}!
                        </span>
                        <span
                          class="subtitle fontsizeinitial h3"
                          data-v-48f3e599=""
                        >
                          Culminaste satisfactoriamente tu curso "{curso.nombre}
                          "
                        </span>
                      </div>
                    ) : (
                      cursoPersona[0].idEstado == 1 &&
                      Evaluaciones &&
                      (cursoPersona[0].promedio <
                        configuraciones?.filter(
                          (z) => z.codigo === "NOTA_MINIMA_APROB"
                        )[0].valor ||
                        cursoPersona[0].idCondicion == 2) && (
                        <div className="field col-12 md:col-8 fontsizeinitial">
                          <span class="subtitle h3" data-v-48f3e599="">
                            ¡Lo sentimos {Persona.nombres}!
                          </span>
                          <span className="fontsizeinitial">
                            Desaprobaste el curso "{curso.nombre}", no podrás
                            obtener tu certificado, sin embargo, si deseas
                            continuar con tu desarrollo académico, puedes seguir
                            revisando el curso.
                          </span>
                        </div>
                      )
                    )
                  ) : (
                    <>
                      <span
                        class="subtitle fontsizeinitial h3"
                        data-v-48f3e599=""
                      >
                        El curso "{curso.nombre}" ha expirado, tu membresia ha
                        finalizado.
                      </span>
                    </>
                  )
                ) : cursoPersona[0].idEstado == 3 ? (
                  <div className="field col-12 md:col-8 fontsizeinitial">
                    <span
                      class="subtitle fontsizeinitial h3"
                      data-v-48f3e599=""
                    >
                      Recuerda que...
                    </span>
                    <span className="fontsizeinitial">
                      Tienes 30 días para culminar el curso "{curso.nombre}"
                      desde que lo activas, una vez comenzado no podras
                      desactivarlo.
                    </span>
                  </div>
                ) : cursoPersona[0].idEstado == 2 ? (
                  cursoExpirado &&
                    cursoPersona[0].fechaAmpliacionCurso == null ? (
                    <div className="field col-12 md:col-8 fontsizeinitial">
                      <span class="subtitle h3" data-v-48f3e599="">
                      ¡Hola {Persona.nombres && Persona.nombres.split(' ')[0]}!
                      </span>
                      <span
                        class="subtitle fontsizeinitial h3"
                        data-v-48f3e599=""
                      >
                        El curso "{curso.nombre}" ha expirado
                      </span>
                      <span className="fontsizeinitial">
                        Puedes solicitar una única ampliación de 14 dias <br />
                        {/* {obtenerPorcentajeAvance() == 0
                              ? ""
                              : "Has avanzado el " +
                                obtenerPorcentajeAvance() +
                                "% del curso ¡Sigue así!"} */}
                        {porcentajeCursoAvance == 0
                          ? ""
                          : "Has avanzado el " +
                          porcentajeCursoAvance +
                          "% del curso ¡Sigue así!"}
                        {/* Has avanzado el {obtenerPorcentajeAvance()}% del curso ¡Sigue así! */}
                      </span>
                    </div>
                  ) : cursoExpiradoAmpliacion ? (
                    <div className="field col-12 md:col-8 fontsizeinitial">
                      <span class="subtitle h3" data-v-48f3e599="">
                      ¡Hola {Persona.nombres && Persona.nombres.split(' ')[0]}!
                      </span>
                      <span
                        class="subtitle fontsizeinitial h3"
                        data-v-48f3e599=""
                      >
                        El curso "{curso.nombre}" ha expirado
                      </span>
                      <span className="fontsizeinitial">
                        Solicitaste una ampliación el{" "}
                        {moment(cursoPersona[0].fechaAmpliacionCurso)
                          .subtract(14, "days")
                          .format("DD/MM/YY")}
                        .
                      </span>
                    </div>
                  ) : (
                    <div className="field col-12 md:col-8 fontsizeinitial">
                      <span className="subtitle h3" data-v-48f3e599="">
                      ¡Hola {Persona.nombres && Persona.nombres.split(' ')[0]}!
                      </span>
                      <span
                        className="subtitle fontsizeinitial h3 "
                        data-v-48f3e599=""
                        style={{ marginTop: "10px" }}
                      >
                        Te damos la bienvenida al curso <br /> "{curso.nombre}"
                      </span>
                      <span className="fontsizeinitial">
                        {/* {obtenerPorcentajeAvance() == 0
                              ? ""
                              : "Has avanzado el " +
                                obtenerPorcentajeAvance() +
                                "% del curso ¡Sigue así!"} */}
                        {porcentajeCursoAvance == 0
                          ? ""
                          : "Has avanzado el " +
                          porcentajeCursoAvance +
                          "% del curso ¡Sigue así!"}
                        {/* Has avanzado el {obtenerPorcentajeAvance()}% del curso ¡Sigue así! */}
                      </span>
                      {porcentajeCursoAvance > 0 && <span><br/></span>}
                      {DiasVigencia() <= 29 && (
                        <span 
                        className=""
                        style={{
                          color: DiasVigencia() <= 7 ? "red" : "inherit",
                        }}
                        >
                          Vence en {DiasVigencia()} días
                        </span>
                      )}
                      {/* <span style={{ color: "red" }} className="pl-2">
                                                  Vence en <DiasVigencia /> días
                                              </span>{" "} */}
                    </div>
                  )
                ) : cursoPersona[0].idEstado == 1 &&
                  cursoPersona[0].idCondicion != 2 &&
                  Evaluaciones &&
                  calcularPromedioNotasPorUnidad() >=
                  configuraciones?.filter(
                    (z) => z.codigo === "NOTA_MINIMA_APROB"
                  )[0].valor ? (
                  <div className="field col-12 md:col-8 fontsizeinitial">
                    <span class="subtitle h3" data-v-48f3e599="">
                      ¡Felicidades {Persona.nombres}!
                    </span>
                    <span
                      class="subtitle fontsizeinitial h3"
                      data-v-48f3e599=""
                    >
                      Culminaste satisfactoriamente tu curso "{curso.nombre}"
                    </span>
                  </div>
                ) : cursoPersona[0].idEstado == 1 &&
                  Evaluaciones &&
                  (calcularPromedioNotasPorUnidad() <
                    configuraciones?.filter(
                      (z) => z.codigo === "NOTA_MINIMA_APROB"
                    )[0].valor ||
                    cursoPersona[0].idCondicion == 2) ? (
                  <div className="field col-12 md:col-8 fontsizeinitial">
                    <span class="subtitle h3" data-v-48f3e599="">
                      ¡Lo sentimos {Persona.nombres}!
                    </span>
                    <span className="fontsizeinitial">
                      Desaprobaste el curso "{curso.nombre}", no podrás obtener
                      tu certificado, sin embargo, si deseas continuar con tu
                      desarrollo académico, puedes seguir revisando el curso.
                    </span>
                  </div>
                ) : (
                  <div className="field col-12 md:col-8 fontsizeinitial">
                    <span
                      class="subtitle fontsizeinitial h3"
                      data-v-48f3e599=""
                    >
                      Recuerda que...
                    </span>
                    <span className="fontsizeinitial">
                      Tienes 30 días para culminar el curso "{curso.nombre}"
                      desde que lo activas, una vez comenzado no podras
                      desactivarlo.
                    </span>
                  </div>
                )}
                <div className="field col-12 md:col-4">
                  <div style={{ marginTop: 30 }} className="progreso-mobile">
                    <ProgressBar
                      className="progressbar"
                      // value={obtenerPorcentajeAvance()}
                      value={porcentajeCursoAvance}
                      displayValueTemplate={valueTemplate}
                      style={{ height: "6px" }}
                    ></ProgressBar>
                  </div>
                  {cursoExpiradoMembresia ? (
                    cursoPersona[0].idCondicion ? (
                      <div className="divBottonAvance">
                        <ButtonZegel
                          clases="marginTopCard"
                          label="¡Seguir aprendiendo!"
                          color="primary"
                          onClick={() => handleLinkClickCursoBase()}
                        ></ButtonZegel>
                      </div>
                    ) : (
                      <div className="divBottonAvance">
                        <ButtonZegel
                          className="divBottonAvance"
                          label="Curso expirado"
                          color="primary"
                          disabled={true}
                        ></ButtonZegel>
                      </div>
                    )
                  ) : cursoPersona[0].idEstado == 3 ? (
                    <div className="divBottonAvance">
                      <ButtonZegel
                        label="Activar curso"
                        color="primary"
                        onClick={() => {
                          setShowAlert(true);
                          setContenidoAlertActivar(contenidoActivar);
                        } }
                      ></ButtonZegel>
                    </div>
                  ) : cursoPersona[0].idEstado == 2 ||
                    (cursoPersona[0].idEstado == 1 &&
                      Evaluaciones &&
                      calcularPromedioNotasPorUnidad() <
                      configuraciones?.filter(
                        (z) => z.codigo === "NOTA_MINIMA_APROB"
                      )[0].valor) ? (
                    cursoExpirado &&
                      cursoPersona[0].fechaAmpliacionCurso == null ? (
                      <div className="divBottonAvance">
                        <ButtonZegel
                          className="divBottonAvance"
                          label="Solicitar ampliación"
                          color="primary"
                          onClick={() => setShowAmpliacion(true)}
                        ></ButtonZegel>

                        <ButtonZegel
                          clases="marginTopCard"
                          label="¡Seguir aprendiendo!"
                          color="secondary"
                          onClick={() => handleLinkClickCursoBase()}
                        ></ButtonZegel>
                      </div>
                    ) : cursoExpiradoAmpliacion ? (
                      <div className="divBottonAvance">
                        <ButtonZegel
                          className="divBottonAvance"
                          label="Curso expirado"
                          color="primary"
                          disabled={true}
                        ></ButtonZegel>

                        <ButtonZegel
                          clases="marginTopCard"
                          label="¡Seguir aprendiendo!"
                          color="primary"
                          onClick={() => handleLinkClickCursoBase()}
                        ></ButtonZegel>
                      </div>
                    ) : (
                      <div className="divBottonAvance">
                        <ButtonZegel
                          label="¡Seguir aprendiendo!"
                          color="primary"
                          onClick={() => handleLinkClickCursoBase()}
                        ></ButtonZegel>
                      </div>
                    )
                  ) : cursoPersona[0].idEstado == 1 ? (
                    <div className="divBottonAvance">
                      <ButtonZegel
                        label="Ver de nuevo"
                        color="primary"
                        onClick={() => navigate(
                          "/" +
                          PrivateRoutes.HOME +
                          "/CursoInterno/" +
                          cursoPersona[0].idPersonaCurso
                        )}
                      ></ButtonZegel>
                    </div>
                  ) : (
                    <div className="divBottonAvance">
                      <ButtonZegel
                        label="Activar curso"
                        color="primary"
                        onClick={() => { } }
                      ></ButtonZegel>
                    </div>
                  )}
                </div>
              </div>
              <div style={{ marginTop: 30 }} className="progreso-desktop-block">
                <ProgressBar
                  className="progressbar"
                  // value={obtenerPorcentajeAvance()}
                  value={porcentajeCursoAvance}
                  displayValueTemplate={valueTemplate}
                  style={{ height: "6px" }}
                ></ProgressBar>
              </div>
            </div>
          </div>
        </div>

        <CardDownloadDesktop
          key={0}
          cursoPersona={cursoPersona}
          curso={curso}
          Persona={Persona}
          Evaluaciones={Evaluaciones}
          calcularPromedioNotasPorUnidad={calcularPromedioNotasPorUnidad}
          isButtonDisabledMateriales={isButtonDisabledMateriales}
          setButtonDisabledMateriales={setButtonDisabledMateriales}
          setspinnerMateriales={setspinnerMateriales}
          idCurso={idCurso}
          spinnerMateriales={spinnerMateriales}
          ProgressSpinner={ProgressSpinner}
          listaUnidades={listaUnidades}
          setspinnerCertificado={setspinnerCertificado}
          spinnerCertificado={spinnerCertificado}
          setspinnerNotas={setspinnerNotas}
          spinnerNotas={spinnerNotas} />
      </div>
      <div className="field col-12 md:col-5 movilBackground">
        <div className="border rounded-9 shadow p-md-4 mb-md-4 cardTabs card3Y4min-height card3Y4minpadding">
          <div className=" rounded-9 shadow ">
            <div className="row g-2 mb-2 align-items-center card__contenedor_video">
              <div className="rounded-10 p-md-4 mb-md-4 title__video__intro__contenedor">
                <span className="title__video__intro " data-v-48f3e599="" >
                  ¿Cómo utilizar la plataforma? Mira el siguiente video.
                </span>
              </div>
              <div className="video_intro">
                {curso && (
                  <ReactPlayer
                    url={"https://vimeo.com/" + curso.videoIntroduccion}
                    width="100%"
                    height={"100%"}
                    controls={true}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <CardCursoVideoInicioComponent curso={curso} /> */}
    </div><DialogZegel
      header=""
      visible={showAmpliacion}
      width="30vw"
      onHide={() => setShowAmpliacion(false)}
      footer={footerAmpliacion}
      contenido={contenidoAmpliacion}
    ></DialogZegel>
    </>
  );
}

export default CardBienvenida;
